import { Box, Skeleton, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
// import { BatteryIcon, CameraIcon, MemoryIcon, ScreenSizeIcon } from '../shared/CustomIcons.styled';
import styles from './styles';

const HandsetSpecification = ({ specs, loadingHandset, description }) => {
  const theme = useTheme();

  return !loadingHandset ? (
    <Stack>
      <Grid container spacing={2} sx={styles(theme).specContainer}>
        {specs?.map((spec, i) => (
          <Grid item xs={3} key={i}>
            <Box
              component='img'
              src={spec?.logo?.path}
              alt={spec?.logo?.altText}
              sx={{ height: 18, width: 20, m: '0 auto', display: 'block', mb: 1 }}
            />
            <Typography
              variant='subtitle2'
              textAlign='center'
              sx={{ color: theme.palette.primary.textColor3 }}
            >
              {spec.value}
            </Typography>
          </Grid>
        ))}
      </Grid>

      <Grid sx={styles(theme).handsetSpecification}>
        <Typography component='p' variant='body1' sx={{ color: theme.palette.primary.textColor3 }}>
          <span dangerouslySetInnerHTML={{ __html: description }} />
        </Typography>
      </Grid>
    </Stack>
  ) : (
    <Stack spacing={2}>
      {/* image specification */}
      <Box sx={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>
        {Array(4)
          .fill()
          .map((_, i) => (
            <Box key={i} sx={{ flex: 0.2 }}>
              <Skeleton variant='rectangular' width={25} height={25} sx={{ m: '0 auto' }} />
              <Skeleton />
            </Box>
          ))}
      </Box>

      {/* Description */}
      <Box sx={{ flex: 1 }}>
        {Array(3)
          .fill()
          .map((_, i) => (
            <Skeleton key={i} variant='text' width='100%' />
          ))}
      </Box>
    </Stack>
  );
};

export default HandsetSpecification;
